//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { formatDate } from "../../../javascript/formatDate"

    export default {
        name: 'Cpts003',
        components: {

        },
        props: {
            data: Array
        },
        watch: {
            data () {
                this.data.map((item) => {
                    if (item._source.updateDate.length > 5) {
                        item._source.updateDate = formatDate(item._source.updateDate, 'yyyy-MM-dd')
                    }
                })
            }
        }
    }
